import { useFormikContext } from "formik";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useGetData } from "..";
import { ENDPOINTS } from "../../constants/endpoints";
import lnMap from "../../languages/language-maps/shared-lang-map";

const defaultCardData = {
  records: [],
  title: "",
  reviews: [],
  rating: "-",
  images: [],
};

function useSumCardLogic() {
  const { t } = useTranslation();
  const { values } = useFormikContext();
  const { company } = useParams();
  const [cardData, setCardData] = useState(defaultCardData);
  const { price = "1.5" } = cardData?.records[0] || {};
  const {
    shipper_name,
    recipient_name,
    shipping_address_city,
    delivery_address_city,
    box_weight,
    coupon_code,
  } = values;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const title = urlParams.get("title");
    const rating = urlParams.get("rating");
    const reviews = urlParams.get("reviews");
    setCardData((prevData) => ({ ...prevData, title, rating, reviews }));
  }, []);

  const info = useMemo(
    () => ({
      shipper_name,
      recipient_name,
      cargo_route: `${shipping_address_city} - ${delivery_address_city}`,
      box_weight,
      price_info: {
        cargo_price: `${+box_weight * +price}$`,
        service_price: t(lnMap.total_free),
        total_sum: `${+box_weight * +price}$`,
      },
      coupon_code,
    }),
    [
      t,
      recipient_name,
      shipper_name,
      box_weight,
      delivery_address_city,
      shipping_address_city,
      coupon_code,
      price,
    ]
  );

  return { info, cardData };
}

export default useSumCardLogic;
